import React, { useContext } from 'react';
import { ThemeContext } from '../context/theme-context';
import { FaQuoteRight, FaStar, FaStarHalfAlt } from 'react-icons/fa';
import styles from '../styles/Testimonials.module.css';
import testimonialData from '../data/testimonialsData';

function StarRating({ rating }) {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;

    return (
        <div className={styles.ratingContainer}>
            {[...Array(fullStars)].map((_, index) => (
                <FaStar key={`full-${index}`} className={styles.ratingIcon} />
            ))}
            {halfStar && <FaStarHalfAlt className={styles.ratingIcon} />}
        </div>
    );
}

function Testimonials() {
    const { theme } = useContext(ThemeContext);

    return (
        <section
            id="testimonials"
            className={styles.testimonialsSection}
            data-theme={theme}
        >
            <div className="container">
                <h2 className="section-title">Testimonials</h2>

                <div className={styles.testimonialsContainer}>
                    {testimonialData.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className={styles.testimonialCard}
                        >
                            <FaQuoteRight className={styles.testimonialQuote} />

                            <p className={styles.testimonialContent}>
                                "{testimonial.testimonial}"
                            </p>

                            <div className={styles.testimonialHeader}>
                                <div className={styles.avatarWrapper}>
                                    <img
                                        src={testimonial.avatar}
                                        alt={`${testimonial.name} avatar`}
                                    />
                                </div>

                                <div className={styles.testimonialInfo}>
                                    <h3 className={styles.testimonialName}>
                                        {testimonial.name}
                                    </h3>
                                    <p className={styles.testimonialPosition}>
                                        {testimonial.position}<br/>{testimonial.company}
                                    </p>
                                    <StarRating rating={testimonial.rating} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Testimonials;